__turbopack_context__.v({
  "shopCardBody": "_4oBR5a_shopCardBody",
  "shopCardBottomSheet": "_4oBR5a_shopCardBottomSheet",
  "shopCardFlipImg": "_4oBR5a_shopCardFlipImg",
  "shopCardFooterRow": "_4oBR5a_shopCardFooterRow",
  "shopCardMedia": "_4oBR5a_shopCardMedia",
  "shopCardMediaDimBackdrop": "_4oBR5a_shopCardMediaDimBackdrop",
  "shopCardPriceCluster": "_4oBR5a_shopCardPriceCluster",
  "shopCardPrimaryCta": "_4oBR5a_shopCardPrimaryCta",
  "shopCardSpecSection": "_4oBR5a_shopCardSpecSection",
  "shopCardTag": "_4oBR5a_shopCardTag",
  "shopProductCardRoot": "_4oBR5a_shopProductCardRoot",
});
